import React, { useEffect, useState } from "react";
import { Icon } from "../../../../components/Component";
import { Spinner } from "reactstrap";
import Toast from "../../../../utils/Toast";
import axios from "axios";

const UpdateLicenceModal = ({ toggle }) => {
  const [licence, setLicence] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [validity, setValidity] = useState("");

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");

  useEffect(() => {
    axios({
      method: "GET",
      url: `${baseUrl}/license/get-token`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;
        setLoading(false);
        setLicence(data?.licence);
        setValidity(data?.validPeriod);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);

        if (error.response !== undefined) {
          Toast("close");
          Toast("error", error.response.data.message);
        } else {
          Toast("close");
          Toast("error", "Something went wrong");
        }
      });
  }, []);

  const updateLicense = () => {
    setLoading(true);
    if (licence === "") {
      Toast("error", "License Key cannot be empty");
      setLoading(false);
    } else {
      axios({
        method: "POST",
        url: `${baseUrl}/user/update-licence`,
        headers: {
          Authorization: token,
        },
        data: {
          licence: licence,
        },
      })
        .then((res) => {
          setLoading(false);
          Toast("close");
          Toast("success", "Licence Updated Successfully");
          toggle();
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);

          if (error.response !== undefined) {
            Toast("close");
            Toast("error", error.response.data.message);
          } else {
            Toast("close");
            Toast("error", "Something went wrong");
          }
        });
    }
  };

  return (
    <div>
      <div className="modal-header align-center">
        <div className="nk-file-title">
          <div className="nk-file-name">
            <div className="nk-file-name-text">
              <span className="title">Update License</span>
            </div>
          </div>
        </div>
        <a
          href="#close"
          onClick={(ev) => {
            ev.preventDefault();
            toggle();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
      </div>
      <div className="modal-body">
        <div className="form-group">
          <p className="text-soft p-0 m-0">Enter the License Key</p>
          <div className="form-control-wrap">
            <textarea
              rows={8}
              id="companyname"
              //   placeholder="license key"
              className="form-control-lg form-control text-info no-resize mt-1"
              value={licence}
              onChange={(e) => {
                setLicence(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <span className={`p-0 m-0`}>
            Validity Period :{" "}
            <span className={`p-0 m-0 ${validity === "PERPETUAL LICENCE" ? "text-success" : "text-warning"}`}>
              {validity}
            </span>
          </span>
        </div>
      </div>
      <div className="modal-footer modal-footer-stretch bg-light">
        <div className="modal-footer-between">
          <div className="g"></div>
          <div className="g">
            <ul className="btn-toolbar g-3">
              <li>
                <a
                  href="#"
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggle();
                  }}
                  className="btn btn-outline-light btn-white"
                >
                  Cancel
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateLicense();
                  }}
                  className="btn btn-primary"
                >
                  {isLoading ? <Spinner size="sm" color="light" /> : "Update"}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateLicenceModal;
